import PropTypes from 'prop-types'
import {Cloudinary} from '@cloudinary/url-gen'
import {fill} from '@cloudinary/url-gen/actions/resize'

import {CLOUDINARY_CLOUD_NAME} from '../../constants'

const extractPublicId = (url) => {
    try {
        const baseUrl = `https://res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}/video/upload/`
        const baseUrlAlt = `https://res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}/image/upload/`
        if (!url?.startsWith(baseUrl) && !url?.startsWith(baseUrlAlt)) {
            console.error('Invalid Cloudinary URL:', url)
            return ''
        }

        const parts = url.split('/upload/')

        if (parts.length < 2) return null // Ensure URL contains "/upload/"

        const afterUpload = parts[1] // Everything after "/upload/"

        // Split by "/" and remove transformation parameters
        const pathSegments = afterUpload.split('/')

        // Find the first segment that is **not** a transformation (i.e., the start of the public ID)
        let publicIdStartIndex = 0
        for (let i = 0; i < pathSegments.length; i++) {
            if (!pathSegments[i].includes('_') && !pathSegments[i].includes(',')) {
                publicIdStartIndex = i
                break
            }
        }

        // Rebuild the public ID from this point onward
        let publicId = pathSegments.slice(publicIdStartIndex).join('/')

        // Remove file extension if present
        publicId = publicId.replace(/\.[^/.]+$/, '')

        // Decode URI (to handle spaces and special characters correctly)
        return decodeURIComponent(publicId)
    } catch (error) {
        console.error('Error extracting publicId:', error)
        return ''
    }
}

const getCloudinaryVideoUrl = ({src, width, height, aspectRatio}) => {
    const publicId = extractPublicId(src)

    if (!publicId) {
        return null
    }

    const cld = new Cloudinary({
        cloud: {cloudName: CLOUDINARY_CLOUD_NAME},
        url: {analytics: false}
    })
    const transformation = fill()

    if (width) {
        transformation.width(width)
    }

    if (height) {
        transformation.height(height)
    }

    if (aspectRatio) {
        transformation.aspectRatio(aspectRatio)
    }

    const video = cld.video(publicId).resize(transformation).format('auto').quality('auto')

    return video.toURL()
}

getCloudinaryVideoUrl.propTypes = {
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    aspectRatio: PropTypes.string
}

export default getCloudinaryVideoUrl
